export const getIconClass = (id: string, size: number, ext: string) => `apps_${id}${ext ? `-${ext}` : ''}-${size}x${size}`;
